var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-denied"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_vm._v("🚫")]),_c('h1',[_vm._v("访问被拒绝")]),_c('p',[_vm._v("您没有权限访问此页面")]),_c('p',{staticClass:"sub"},[_vm._v("Access Denied")])])])
}]

export { render, staticRenderFns }